import { render, staticRenderFns } from "./number-validated.vue?vue&type=template&id=647ec072&"
import script from "./number-validated.vue?vue&type=script&lang=js&"
export * from "./number-validated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports